import * as React from "react";
import Svg, { Path } from "react-native-svg";
function RightBlackIcon(props) {
    return (React.createElement(Svg, { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
        React.createElement(Path, { d: "M12.561 10a.61.61 0 01-.041.229.636.636 0 01-.146.208l-4.125 4.125a.573.573 0 01-.448.157.64.64 0 01-.448-.178c-.139-.138-.198-.288-.177-.447a.783.783 0 01.198-.428L11.04 10 7.373 6.333a.68.68 0 01-.188-.448.493.493 0 01.188-.448.46.46 0 01.437-.177c.18.021.334.087.459.198l4.104 4.104c.07.07.118.14.146.209.027.07.041.146.041.229z", fill: props.color })));
}
export default RightBlackIcon;
